var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FilePond',{ref:"pond",attrs:{"name":"prueba","maxFiles":_vm.maxFiles,"allowMultiple":"true","acceptedFileTypes":"image/jpeg, image/png","server":{  process: _vm.process, revert: _vm.revert,  restore: _vm.restore, load: _vm.load, fetch: _vm.fetch },"files":_vm.files}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }